/* eslint @typescript-eslint/no-explicit-any: 0 */

import { Tag, newTag } from "../types/Tag";
import TagForm from "../components/tags/TagForm";
import { useCreateTagMutation } from "../../features/api/tagSlice";

import React, { useState } from "react";
import { Box, Container, Toolbar, Card, CardContent, Typography } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

const NewTag: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [createTag, { isLoading: loadingCreateTag }] = useCreateTagMutation();
    const enteredText: string = location.state ? location.state.enteredText : "";
    window.history.replaceState({}, ""); // reset state
    const [tag, setTag] = useState<Tag>(newTag(enteredText));

    async function handleTagSubmit() {
        // Submit question through api
        if (!loadingCreateTag) {
            try {
                await createTag(tag).unwrap();
                navigate("/tags");
                return true;
            } catch (error: any) {
                if (error.status === 400) {
                    return false;
                } else {
                    throw error;
                }
            }
        }
        return true;
    }

    function handleTagCancel() {
        navigate("/tags");
    }

    return (
        <Box
            component="main"
            sx={{
                backgroundColor: (theme) =>
                    theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[900],
                flexGrow: 1,
                height: "100vh",
                overflow: "auto",
            }}
        >
            <Toolbar />
            <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
                <Card sx={{ display: "grid" }}>
                    <CardContent>
                        <Typography variant="h4" m={2}>
                            Create a tag
                        </Typography>
                        <Box m={2}>
                            <TagForm
                                tag={tag}
                                onTagChange={setTag}
                                onSubmit={handleTagSubmit}
                                onCancel={handleTagCancel}
                            />
                        </Box>
                    </CardContent>
                </Card>
            </Container>
        </Box>
    );
};

export default NewTag;
